import { setPayableSession } from "actions/payableSessionActions";
import IamApi from "api/IamApi";
import { useBiller } from "hooks";
import { Spinner } from "kubra-ux-forge";
import _ from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import routing from "routing";
import { getDeviceFingerprint } from "selectors/appState";
import { InvoicePayable } from "types/payable";
import { getDomain, isInvoiceOrAccountKrn } from "utilities/helper";

export const PayableCsrDirectLanding = () => {
  const dispatch = useDispatch();

  // TODO: find out how is the fingerprint provided for CSR direct landing initiated payments?
  const fingerprint = useSelector(getDeviceFingerprint);

  const { getBiller } = useBiller();
  const biller = getBiller();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const domain = getDomain();

    const getPaymentIntentId = () => {
      const match = matchPath(
        routing.payableCsrDirectLanding.read(":paymentIntentId"),
        location.pathname
      );
      return _.get(match, ["params", "paymentIntentId"]);
    };

    const paymentIntentId = getPaymentIntentId();

    if (!paymentIntentId) {
      throw new Error("Failed to retrieve payment intent ID from path");
    }

    const payableKrn =
      new URLSearchParams(location.search).get("payableKrn") ?? undefined;

    if (payableKrn !== undefined && !isInvoiceOrAccountKrn(payableKrn)) {
      console.error(`Invalid payableKrn: ${payableKrn}`);
      navigate(routing.index());
      return;
    }

    IamApi.ezpay
      .getPayableCsrDirectLanding(
        biller.spaceKrn,
        paymentIntentId,
        domain,
        payableKrn
      )
      .then((payableSession) => {
        dispatch(setPayableSession(payableSession));
        // Navigate to the details page if the payable is an invoice with extension fields Otherwise navigate to the dashboard
        if (payableSession?.payableType?.category?.toLowerCase() === "invoice"){
          // If the invoice is voided or archived navigate to Invoice or Archived view
          const invoicePayable = payableSession?.payable as InvoicePayable;
          if (invoicePayable?.voided === true || invoicePayable?.archived === true) {
            navigate(routing.itemVoidedArchived.index());
            return; 
          }          
          if (payableSession?.payableType?.extensionFields?.length > 0) {
            navigate(routing.payableDetails.index());
            return;
          } else {
            navigate(routing.payableDashboard.index());
            return;
          }
        }
        else {
          navigate(routing.payableDashboard.index());          
        }
      })
      .catch((error) => {
        console.error(error);
        navigate(routing.index());
      });
    // This useEffect should only run once, on initial render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            margin: "0 auto",
            height: "50vh",
            backgroundColor: "white",
            width: "75vw",
            justifyContent: "center",
            borderRadius: "24px",
            verticalAlign: "middle",
          }}
        >
          <Spinner size="large" variant="primary" />
        </div>
      </div>
    </>
  );
};

export default PayableCsrDirectLanding;
